import { LOG_TYPE } from "./HomeTracking/contants";

export type WorkerLogtimePunchEvent = {
  companyId: string;
  workerId: number;
  workDate: string;
  logType: LOG_TYPE;
};

const CHANNEL_NAME = "lhd-worker-logtime-punch";
const STORAGE_KEY = "lhd-worker-logtime-punch";

export const isOpenSessionAfterPunch = (logType: LOG_TYPE): boolean =>
  logType === LOG_TYPE.CHECKIN ||
  logType === LOG_TYPE.BREAK_START ||
  logType === LOG_TYPE.BREAK_END;

export function broadcastWorkerLogtimePunch(event: WorkerLogtimePunchEvent) {
  if (typeof window === "undefined") return;

  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(event);
    channel.close();
  }

  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...event, ts: Date.now() }),
    );
  } catch (error) {
    console.warn("Failed to write punch event to localStorage:", error, event);
  }
}

export function subscribeWorkerLogtimePunch(
  handler: (event: WorkerLogtimePunchEvent) => void,
): () => void {
  if (typeof window === "undefined") return () => undefined;

  const onMessage = (event: WorkerLogtimePunchEvent) => handler(event);

  let channel: BroadcastChannel | undefined;
  if (typeof BroadcastChannel !== "undefined") {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (message) =>
      onMessage(message.data as WorkerLogtimePunchEvent);
  }

  const onStorage = (storageEvent: StorageEvent) => {
    if (storageEvent.key !== STORAGE_KEY || !storageEvent.newValue) return;
    try {
      const parsed = JSON.parse(
        storageEvent.newValue,
      ) as WorkerLogtimePunchEvent;
      onMessage(parsed);
    } catch (error) {
      console.warn(
        "Ignored malformed punch payload from storage:",
        error,
        storageEvent.newValue,
      );
    }
  };

  window.addEventListener("storage", onStorage);

  return () => {
    channel?.close();
    window.removeEventListener("storage", onStorage);
  };
}
